import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '.';
import {
  FilterTypes,
  INTIAL_FILTERS,
  NEW_VEHICLE_FILTERS_LIST,
  DEFAULT_FILTER_POSITIONS,
  DEFAULT_FILTER_STATES,
} from '../constants/initialFilters';

export type listOfDealersType = {
  dealerName: string;
  dealerId: string;
  isMainDealer: boolean;
};

export type AvailabilityOptions = {
  now: {
    label: string;
  };
  all: {
    label: string;
  };
};

interface ConfigReducerTypes {
  listOfDealers: listOfDealersType[];
  isImageGalleryOn: boolean;
  isUrlParamsDynamic: boolean;
  dataSource: string;
  isTier3page: boolean;
  marketType: string;
  pageTitle: string;
  commonModelFamilies: string[];
  pageDescription: string;
  filterGroupsToRender: string[];
  tier3Filters: FilterTypes;
  vehicleTypeDisplayOptions: string[];
  availabilityOptions: AvailabilityOptions;
  filterTrayState: 'open' | 'closed';
}

const initialState = {
  listOfDealers: [
    { dealerName: 'Audi Test 1', dealerId: '25A70', isMainDealer: true },
    { dealerName: 'Audi Test 2', dealerId: '25A72', isMainDealer: false },
    { dealerName: 'Audi Test 3', dealerId: '25A73', isMainDealer: false },
  ],
  isUrlParamsDynamic: false,
  dataSource: 'jdp',
  isImageGalleryOn: true,
  isTier3page: false,
  marketType: 'USA',
  pageTitle: 'Vehicle Inventory test',
  pageDescription: '',
  commonModelFamilies: [],
  filterGroupsToRender: NEW_VEHICLE_FILTERS_LIST,
  tier3Filters: INTIAL_FILTERS,
  vehicleTypeDisplayOptions: [],
  availabilityOptions: {
    now: {
      label: '',
    },
    all: {
      label: '',
    },
  },
  filterTrayState: 'open',
  filterPositions: DEFAULT_FILTER_POSITIONS,
  filterPanelStates: DEFAULT_FILTER_STATES,
};

const appConfigSlice = createSlice({
  name: 'appConfig',
  initialState,
  reducers: {
    setConfig: (_state, action) => {
      return action.payload;
    },
    setMarket: (state, action) => {
      return { ...state, marketType: action.payload };
    },
  },
});

export const selectAppConfig = (state: RootState) => state.config;

export const { setConfig, setMarket } = appConfigSlice.actions;

export default appConfigSlice.reducer;
